export default __webpack_public_path__ + "static/section2-others-eaeb9446334078af4b2dcb1661b27a1d.webp";